import styled from "styled-components";

import { theme } from "../../styles/theme";

type ButtonProps = {
  color?: string;
  backgroundColor?: string;
  title?: string;
  hasRecurrence?: string;
  minWidth?: number | string;
};

export const ButtonWrapper = styled.button`
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  background-color: ${(props: ButtonProps) => props.backgroundColor};
  color: ${(props: ButtonProps) => props.color};
  line-height: 1;
  height: 29px;
  min-width: 29px;
  min-height: 29px;
  display: flex;
  margin-right: ${(props: ButtonProps) => props.hasRecurrence ? "15px" : "0"};
  aspect-ratio: 1 / 1;

  &:hover {
    opacity: 1;
  }
  &:disabled {
    opacity: 0.4;
  }
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    opacity: 0;
    transition: opacity 0.3s;
  }

  &:hover::before {
    content: "${(props: ButtonProps) => props.title}";
    position: absolute;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${theme.colors.white};
    padding: 5px 10px;
    border-radius: 8px;
    font-size: 12px;
    font-weight: 500;
    color: ${theme.colors.darkBlue};
    z-index: 999;
    opacity: 1;
    white-space: nowrap;
    width: max-content;
  }

  &:hover::after {
    content: "";
    position: absolute;
    top: -14px;
    left: 50%;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    border-top: 10px solid ${theme.colors.white};
    z-index: 999;
    opacity: 1;
  }
`;
